import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html'
})
export class ConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title?: string; body?: string; translateParams?: string }
  ) {}

  confirm() {
    this.dialogRef.close(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/confirmation-dialog/confirmation-dialog.component.ts